import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RequestStatus } from '@app/constants';
import { IInterviewee, IIntervieweeState, IPromoteAsIntern } from './types';
import { IRequestFailed } from '@app/types';
const initialState: IIntervieweeState = {
  addInterviewee: {},
  updateInterviewee: {},
  Interviewee: {},
  promoteAsIntern: {},
  updateIntervieweeStatus: {},
  searchInterviewee: {},
  candidateSearch: {},
};
const slice = createSlice({
  name: 'Interviewee',
  initialState,
  reducers: {
    addInterviewee(state, action: PayloadAction<IInterviewee>) {
      state.addInterviewee.status = RequestStatus.RUNNING;
    },
    addIntervieweeSuccess(state, action) {
      state.addInterviewee.status = RequestStatus.SUCCESS;
      state.addInterviewee.data = action.payload;
      if (state.Interviewee.data) {
        state.Interviewee.data = [action.payload, ...state.Interviewee.data];
      }
    },
    addIntervieweeFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addInterviewee.status = RequestStatus.ERROR;
      state.addInterviewee.error = action.payload;
    },
    //
    updateInterviewee(state, action) {
      state.updateInterviewee.status = RequestStatus.RUNNING;
    },
    updateIntervieweeSuccess(state, action: PayloadAction<IInterviewee>) {
      state.updateInterviewee.status = RequestStatus.SUCCESS;
      state.updateInterviewee.data = action.payload;
    },
    updateIntervieweeFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateInterviewee.status = RequestStatus.ERROR;
      state.updateInterviewee.error = action.payload;
    },
    //
    updateIntervieweeStatus(state, action) {
      state.updateIntervieweeStatus.status = RequestStatus.RUNNING;
    },
    updateIntervieweeStatusSuccess(state, action: PayloadAction<IInterviewee>) {
      state.updateIntervieweeStatus.status = RequestStatus.SUCCESS;
      state.updateIntervieweeStatus.data = action.payload;
    },
    updateIntervieweeStatusFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateIntervieweeStatus.status = RequestStatus.ERROR;
      state.updateIntervieweeStatus.error = action.payload;
    },
    //
    promoteAsIntern(state, action) {
      state.promoteAsIntern.status = RequestStatus.RUNNING;
    },
    promoteAsInternSuccess(state, action: PayloadAction<IPromoteAsIntern>) {
      state.promoteAsIntern.status = RequestStatus.SUCCESS;
      state.promoteAsIntern.data = action.payload;
    },
    promoteAsInternFailed(state, action: PayloadAction<IRequestFailed>) {
      state.promoteAsIntern.status = RequestStatus.ERROR;
      state.promoteAsIntern.error = action.payload;
    },
    //

    getInterviewee(state) {
      state.Interviewee.status = RequestStatus.RUNNING;
    },
    getIntervieweeSuccess(state, action: PayloadAction<IIntervieweeState['Interviewee']['data']>) {
      state.Interviewee.status = RequestStatus.SUCCESS;
      state.Interviewee.data = action.payload;
    },
    getIntervieweeFailed(state, action: PayloadAction<IRequestFailed>) {
      state.Interviewee.status = RequestStatus.ERROR;
      state.Interviewee.error = action.payload;
    },
    //
    getCandidateSearch(state, action: PayloadAction<string | undefined>) {
      state.candidateSearch.status = RequestStatus.RUNNING;
    },
    getCandidateSearchSuccess(
      state,
      action: PayloadAction<IIntervieweeState['Interviewee']['data']>
    ) {
      state.candidateSearch.status = RequestStatus.SUCCESS;
      state.candidateSearch.data = action.payload;
    },
    getCandidateSearchFailed(state, action: PayloadAction<IRequestFailed>) {
      state.candidateSearch.status = RequestStatus.ERROR;
      state.candidateSearch.error = action.payload;
    },
    //
    searchInterviewee(state, action: PayloadAction<string>) {
      state.searchInterviewee.status = RequestStatus.RUNNING;
    },
    searchIntervieweeSuccess(
      state,
      action: PayloadAction<IIntervieweeState['Interviewee']['data']>
    ) {
      state.searchInterviewee.status = RequestStatus.SUCCESS;
      state.searchInterviewee.data = action.payload;
    },
    searchIntervieweeFailed(state, action: PayloadAction<IRequestFailed>) {
      state.searchInterviewee.status = RequestStatus.ERROR;
      state.searchInterviewee.error = action.payload;
    },
  },
});
export default slice.reducer;
export const {
  addInterviewee,
  addIntervieweeFailed,
  addIntervieweeSuccess,
  updateInterviewee,
  updateIntervieweeSuccess,
  updateIntervieweeFailed,
  promoteAsIntern,
  promoteAsInternSuccess,
  promoteAsInternFailed,
  getInterviewee,
  getIntervieweeSuccess,
  getIntervieweeFailed,
  updateIntervieweeStatus,
  updateIntervieweeStatusFailed,
  updateIntervieweeStatusSuccess,
  searchInterviewee,
  searchIntervieweeFailed,
  searchIntervieweeSuccess,
  getCandidateSearch,
  getCandidateSearchSuccess,
  getCandidateSearchFailed,
} = slice.actions;
